module.exports = __webpack_public_path__ + "img/0Q3B1666_FoamcoreMatted.ddd280d8.jpg";